import { Entidad } from "../../../../data/Entidad";
import { MEscuela } from "../../../../data/model/MEscuela";
import { IGridExtraColumns } from "../entidad/GridExtraColumns";
import { MEscolaridadGrid } from "./MEscolaridadGrid";

export class MEscuelaGrid extends MEscuela implements IGridExtraColumns {
    TagNivel: string | number;
    TagGrado: string | number;
    TagGrupo: string | number;
    TagAlumno: string | number;
    Alumnos: Map<number, Entidad.IAlumno>;

    Niveles: MEscolaridadGrid[]

    constructor(schoolModel: MEscuela) {
        super(schoolModel);
        this.Alumnos = this.alumnosDeEscuela;
        this.TagAlumno = Array.from(this.Alumnos.values())
            .filter(d => (d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo)).length;

        this.Niveles = Array.from(this.escolaraidadesDeEscuela.values())
            .map(nivel => new MEscolaridadGrid(nivel));

        this.TagNivel = this.Niveles.length;

        this.TagGrado = this.Niveles.reduce((suma, nivel) => suma + (nivel.TagGrado as number), 0);
        this.TagGrupo = this.Niveles.reduce((suma, nivel) => suma + (nivel.TagGrupo as number), 0);
    }

    public getAlumnosActivos(): number {
        return Array.from(this.Alumnos.values())
            .filter(d => (d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo))
            .length;
    }
}